export const seekBlueLight700 = '#1E47A9';
export const seekBlueLight800 = '#122F83';
export const seekRaspberryPink700 = '#E60278';
export const seekDeepMagenta700 = '#E60277';
